import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import SvnLogo from "@/components/SvnLogo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin");
    else setErr(res.error);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#0F0F0F] border border-white/10 p-10">
        <div className="text-center">
          <SvnLogo size="md" />
          <p className="mt-4 font-display text-2xl font-bold">Admin Sign In</p>
          <p className="mt-2 text-sm text-neutral-400 font-body">
            Restricted access — network management only.
          </p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.3em] text-neutral-400">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="mt-2 w-full bg-black border border-white/15 px-4 py-3 text-white focus:outline-none focus:border-gold"
            />
          </div>
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.3em] text-neutral-400">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="mt-2 w-full bg-black border border-white/15 px-4 py-3 text-white focus:outline-none focus:border-gold"
            />
          </div>
          {err && (
            <p
              role="alert"
              className="text-sm text-svn-red bg-svn-red/10 border border-svn-red/30 px-3 py-2"
              data-testid="admin-login-error"
            >
              {err}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full bg-svn-red text-white font-black uppercase tracking-widest text-sm px-8 py-4 hover:bg-red-700 transition disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
